export const findAppliedAppleFilter = appliedFilters => {
  return appliedFilters.find(
    appliedFilter =>
      (appliedFilter.id === 'brands' && appliedFilter.filter === 'filter=brands:apple') ||
      (appliedFilter.id === 'type' && appliedFilter.filter === 'filter=type:apple+mac')
  )
}
